import styled from "styled-components";

export const ButtonCloseModal = styled.button`
  width: 100%;
  max-width: 309px;
  height: 30px !important;

  font-size: 14px;
  font-weight: 500;
  color: #fff !important;
  font-family: "Work Sans", sans-serif;

  cursor: pointer;
  margin-bottom: 16px;
  border-radius: 26px;
  padding: 0 30px!important;
  border: 1px solid #3DA8FE !important;
  background-color: #3DA8FE !important;
`;
